import { BudgetColumn } from "@project/domain/models/budget/financial-entity-budget.model";

export class CreateBudgetColumn {
    constructor(
        public name: BudgetColumn["name"],
        public budget: BudgetColumn["budget"],
        public type: BudgetColumn["type"],
    ) {}
}
